<template>
  <div class="quickscanmap">
    <div class="row no-gutters" v-if="title">
      <div class="col text-left">
        <h4 style="margin-top: 4px">{{ title }}</h4>
      </div>
      <div class="col text-right" style="padding: 9px 5px 0px 0px">
        <form style="font-size: 0.65em; padding-top: 5px">
          <input
            class="form-check-input"
            v-model="advancedSettings"
            type="checkbox"
            id="display-all-settings"
          />
          <label for="display-all-settings">Advanced&nbsp;</label>
        </form>

        <!--
        <ul class="cmd-group">
          <li class="title"><a href="#" @click.prevent="nextBackground">Background</a></li>
          <li v-for="background in backgroundLayers">
            <a href="#" :class="{ active:isActiveBackground(background) }" @click.prevent="setBackground(background)">{{ backgroundMaps[background].label }}</a>
          </li>
        </ul>
        -->
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col"><hr style="margin: 0px 0px" /></div>
    </div>
    <div class="row no-gutters" style="padding-bottom: 0px">
      <div class="col col-9" style="padding: 3px 10px">
        <h5>
          Select an indicator to explore:
          <a
            class="explainer-link"
            href="#"
            @click.prevent="explainerStart('summary_stats_indicators')"
            style="font-size: 1em"
            ><i class="bi bi-question-circle"></i
          ></a>
        </h5>

        <form id="quickscan-indicators">
          <div class="row no-gutters" style="background: none">
            <template v-for="indicator in enabledIndicators">
              <div class="form-check" style="width: 50%">
                <input
                  class="form-check-input"
                  v-model="selectedIndicator"
                  type="radio"
                  :value="indicator"
                  :id="
                    'indicator-' +
                    indicator.provider +
                    '-' +
                    indicator.indicator
                  "
                  name="indicators"
                  checked
                />
                <label
                  class="form-check-label"
                  :for="
                    'indicator-' +
                    indicator.provider +
                    '-' +
                    indicator.indicator
                  "
                  >{{ indicator.name }}</label
                >
              </div>
            </template>
          </div>
        </form>
      </div>

      <div
        class="col col-3"
        style="padding: 3px 10px; border-left: 1px solid #ddd"
      >
        <h5>Display results as:</h5>
        <div
          class="form-check"
          v-for="unit in availableUnits"
          style="font-size: 0.75em"
        >
          <input
            class="form-check-input"
            type="radio"
            name="units"
            :id="unit.name"
            :value="unit.name"
            v-model="selectedUnits"
          />
          <label class="form-check-label" :for="unit.name">
            {{ unit.label }}
          </label>
        </div>
      </div>
    </div>

    <div
      class="row no-gutters"
      style="padding-bottom: 7px"
      v-if="advancedSettings"
    >
      <div class="col col-12">
        <hr style="margin-top: 0px; margin-bottom: 4px" />

        <div style="padding: 0px 10px">
          <h5 style="margin-top: 5px">Aggregation level:</h5>
          <form id="quickscan-analysisLevel" v-if="true">
            <div class="row no-gutters" style="background: none">
              <div class="col">
                <div
                  class="form-check form-check-inline"
                  v-for="level in levelPropertiesSorted"
                >
                  <input
                    class="form-check-input"
                    v-model="analysisLevel"
                    type="radio"
                    :value="level.id"
                    :id="'analysis-' + level.id"
                    name="analysis-level"
                  />
                  <label class="form-check-label" :for="'analysis-' + level.id">
                    <span v-if="level.enabled">{{ level.label }}</span>
                    <span v-else style="color: #bbb">{{ level.label }}</span>
                    <span style="color: #bbb">({{ level.count }})</span>
                  </label>
                </div>
              </div>
            </div>
          </form>

          <h5>Additional indicators:</h5>
          <form id="quickscan-indicators-disabled">
            <div class="row no-gutters" style="background: none">
              <template v-for="indicator in disabledIndicators">
                <div class="form-check" style="width: 33%">
                  <input
                    class="form-check-input"
                    v-model="selectedIndicator"
                    type="radio"
                    :value="indicator"
                    :id="
                      'indicator-' +
                      indicator.provider +
                      '-' +
                      indicator.indicator
                    "
                    name="indicators"
                    checked
                  />
                  <label
                    class="form-check-label"
                    :for="
                      'indicator-' +
                      indicator.provider +
                      '-' +
                      indicator.indicator
                    "
                    >{{ indicator.name }}</label
                  >
                </div>
              </template>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="row no-gutters" style="">
      <div class="col">
        <hr style="margin-top: 0px; margin-bottom: 10px" />
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col">
        <div ref="map" class="map" style="height: 450px"></div>
      </div>

      <div class="col">
        <div
          style="
            width: 100%;
            height: 450px;
            overflow-x: hidden;
            overflow-y: scroll;
          "
          id="results-scroll-container"
        >
          <ul id="result-list">
            <li
              v-for="(result, n) in results"
              class="result-item"
              :id="result.fid"
              :key="result.id"
            >
              <div
                class="wrapper"
                @mouseover="highlightFeatureStart(result.fid)"
                @mouseout="highlighFeatureStop()"
                :class="{ wrapperActive: featureHighlight == result.fid }"
              >
                <div v-if="result.indicator == 'treeloss_primary_2021_ha'">
                  <div
                    style="float: right; font-size: 1.2em"
                    :title="indicatorValueRaw(result)"
                  >
                    <strong>{{ indicatorValueFormatted(result) }}</strong>
                    <div :style="circleStyle(result)">
                      <div style="width: 100%; height: 100%"></div>
                    </div>
                  </div>
                  <span style="color: #888">{{ n + 1 }}.</span>
                  {{ titleFor(result.fid) }}
                </div>

                <template v-if="result.indicator == 'treeloss_other_2021_ha'">
                  <div
                    style="float: right; font-size: 1.2em"
                    :title="indicatorValueRaw(result)"
                  >
                    <strong>{{ indicatorValueFormatted(result) }}</strong>
                    <div :style="circleStyle(result)">
                      <div style="width: 100%; height: 100%"></div>
                    </div>
                  </div>
                  <span style="color: #888">{{ n + 1 }}.</span>
                  {{ titleFor(result.fid) }}
                </template>

                <template v-if="result.indicator == 'primary_forest_2021_ha'">
                  <div
                    style="float: right; font-size: 1.2em"
                    :title="indicatorValueRaw(result)"
                  >
                    <strong>{{ indicatorValueFormatted(result) }}</strong>
                    <div :style="circleStyle(result)">
                      <div style="width: 100%; height: 100%"></div>
                    </div>
                  </div>
                  <span style="color: #888">{{ n + 1 }}.</span>
                  {{ titleFor(result.fid) }}
                </template>

                <template v-if="result.indicator == 'svi_integrated_risk'">
                  <div
                    style="float: right; font-size: 1.2em"
                    :title="indicatorValueRaw(result)"
                  >
                    <strong>{{ indicatorValueFormatted(result) }}</strong>
                    <div :style="circleStyle(result)">
                      <div style="width: 100%; height: 100%"></div>
                    </div>
                  </div>
                  <span style="color: #888">{{ n + 1 }}.</span>
                  {{ titleFor(result.fid) }}
                </template>

                <template v-if="result.indicator == 'forest_integrity_mean'">
                  <div
                    style="float: right; font-size: 1.2em"
                    :title="indicatorValueRaw(result)"
                  >
                    <strong v-if="result.value">{{
                      indicatorValueFormatted(result)
                    }}</strong>
                    <strong v-else="result.value" style="color: #666"
                      >&ndash;</strong
                    >
                    <div :style="circleStyle(result)">
                      <div style="width: 100%; height: 100%"></div>
                    </div>
                  </div>
                  <span style="color: #888">{{ n + 1 }}.</span>
                  {{ titleFor(result.fid) }}
                </template>

                <template v-if="result.indicator == 'radd_alerted_ha'">
                  <div
                    style="float: right; font-size: 1.2em"
                    :title="indicatorValueRaw(result)"
                  >
                    <strong>{{ indicatorValueFormatted(result) }}</strong>
                    <div :style="circleStyle(result)">
                      <div style="width: 100%; height: 100%"></div>
                    </div>
                  </div>
                  <span style="color: #888">{{ n + 1 }}.</span>
                  {{ titleFor(result.fid) }}
                </template>

                <template v-if="result.indicator == 'carbon_flux_average_ha'">
                  <div
                    style="float: right; font-size: 1.2em"
                    :title="indicatorValueRaw(result)"
                  >
                    <i v-if="result.value > 0" class="bi bi-arrow-up-short"></i>
                    <i
                      v-if="result.value < 0"
                      class="bi bi-arrow-down-short"
                    ></i>
                    <strong>{{ indicatorValueFormatted(result) }}</strong>
                    <div :style="circleStyle(result)">
                      <div style="width: 100%; height: 100%"></div>
                    </div>
                  </div>
                  <span style="color: #888">{{ n + 1 }}.</span>
                  {{ titleFor(result.fid) }}
                </template>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row no-gutters" v-if="attribution">
      <p class="attribution">{{ attribution }}</p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Leaflet from "leaflet";
import "leaflet/dist/leaflet.css";
import omnivore from "@mapbox/leaflet-omnivore";

export default {
  name: "IndicatorMap",
  components: {},
  props: [
    "test",
    "location",
    "source",
    "title",
    "description",
    "layout",
    "attribution",
    "factsheet",
    "loaded",
    "layers",
    "backgrounds",
  ],
  data() {
    return {
      availableLevels: new Set(),
      levelProperties: {},
      advancedSettings: false,
      availableUnits: [],
      selectedUnits: "hectare",
      analysisLevel: null,
      indicator: ["esa_worldcover", "gfw_treeloss"],
      availableIndicators: [],
      availableIndicatorsByName: {},
      selectedIndicator: null,
      legend: null,
      accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
      layer: null,
      data: null,
      mapBackground: null,
      backgroundLayers: [],
      background: null,
      opacities: [10, 50, 100],
      opacity: 100,
      analysisUnits: null,
      resultCollection: [],
      featureCollection: [],
      indicatorCollection: [],
      featureInfo: {},
      featureList: {},
      featureKeys: [],
      featureHighlight: null,
      highlightLayer: null,
      labelsLayer: null,
      sortBy: null,
      sortOrder: "desc",
      namedColorMaps: {
        BuGn: [
          "#e5f5f9",
          "#ccece6",
          "#99d8c9",
          "#66c2a4",
          "#41ae76",
          "#238b45",
          "#006d2c",
          "#00441b",
        ],
        OrRd: [
          "#fee8c8",
          "#fdd49e",
          "#fdbb84",
          "#fc8d59",
          "#ef6548",
          "#d7301f",
          "#b30000",
          "#7f0000",
        ],
        BuPu: [
          "#ece7f2",
          "#d0d1e6",
          "#a6bddb",
          "#74a9cf",
          "#3690c0",
          "#0570b0",
          "#045a8d",
          "#023858",
        ],
        RdYlGn: [
          "#d73027",
          "#f46d43",
          "#fdae61",
          "#fee08b",
          "#ffffbf",
          "#d9ef8b",
          "#a6d96a",
          "#66bd63",
          "#1a9850",
        ],
        RdYlBu: [
          "#d73027",
          "#f46d43",
          "#fdae61",
          "#fee090",
          "#ffffbf",
          "#e0f3f8",
          "#abd9e9",
          "#74add1",
          "#4575b4",
        ],
        PRGn: [
          "#762a83",
          "#9970ab",
          "#c2a5cf",
          "#e7d4e8",
          "#f7f7f7",
          "#d9f0d3",
          "#a6dba0",
          "#5aae61",
          "#1b7837",
        ],
        Spectral: [
          "#d53e4f",
          "#f46d43",
          "#fdae61",
          "#fee08b",
          "#ffffbf",
          "#e6f598",
          "#abdda4",
          "#66c2a5",
          "#3288bd",
        ],
      },
    };
  },
  created() {},
  updated() {},
  mounted() {
    // Create the map
    this.map = L.map(this.$refs.map, {
      attributionControl: false,
      scrollWheelZoom: false,
    });
    L.control.scale().addTo(this.map);

    this.map.createPane("background");
    this.map.getPane("background").style.pointerEvents = "none";
    this.map.getPane("background").style.zIndex = 100;

    this.map.createPane("data");
    this.map.getPane("data").style.zIndex = 200;

    this.map.createPane("foreground");
    this.map.getPane("foreground").style.pointerEvents = "none";
    this.map.getPane("foreground").style.zIndex = 900;

    /* This component always uses 'light' map as a background. */
    var url =
      process.env.VUE_APP_API +
      "/tools/layer/GeofolioBackgroundLight/v0?z={z}&x={x}&y={y}";
    this.mapBackground = L.tileLayer(url, {
      attribution: "",
      maxZoom: 22,
      pane: "background",
    }).addTo(this.map);

    /* This component always uses 'light' map as a background. */
    var url =
      process.env.VUE_APP_API +
      "/tools/layer/GeofolioLightLabels/v0?z={z}&x={x}&y={y}";
    this.mapBackground = L.tileLayer(url, {
      attribution: "",
      maxZoom: 22,
      pane: "foreground",
    }).addTo(this.map);

    this.loadMap();
    //this.loadLegend();
  },
  watch: {
    loaded() {
      this.loadMap();
      //this.loadLegend();
    },
    analysisLevel() {
      this.updateMap();
    },
    selectedUnits() {
      this.updateMap();
    },
    selectedIndicator() {
      /* Update the available and selected units */
      if (this.selectedIndicator != null) {
        this.availableUnits = this.selectedIndicator["units"];
        this.availableUnits.forEach((u) => {
          if (u["default"] == true) {
            this.selectedUnits = u.name;
          }
        });
        this.updateMap();
      }
    },
    featureHighlight() {
      var feature_id = this.featureHighlight;

      if (this.featureHighlight) {
        /* a feature is selected */
        if (this.highlightLayer) {
          this.map.removeLayer(this.highlightLayer);
        }
        if (this.labelsLayer) {
          this.map.removeLayer(this.labelsLayer);
        }
        /* obtain the scroll offset of said feature */
        var offset = document.getElementById(feature_id).offsetTop;
        var scrollTop = document.getElementById(
          "results-scroll-container"
        ).scrollTop;
        /* scroll the subwindow to the correct offset */
        if (offset > scrollTop && offset < scrollTop + 450) {
          /* its already in view, don't scroll... */
        } else {
          document.getElementById("results-scroll-container").scrollTop =
            offset;
        }

        /* 
          Create and add the hightlight layer that shows the selected feature
          outline.
          */
        var featJson = {
          type: "FeatureCollection",
          name: "aois",
          features: [this.featureList[this.featureHighlight]],
        };
        this.highlightLayer = L.geoJson(this.labelsGeoJSON(), {
          interactive: false,
          style: function (feature) {
            return {
              color: "red",
              weight: 2,
              opacity: 1,
              fillColor: "yellow",
              fillOpacity: 0,
            };
          },
        });
        this.highlightLayer.addTo(this.map);
        /*
          var props = this.featureList[this.featureHighlight]['properties']
          var center = this.highlightLayer.getBounds().getCenter();
          var myIcon = L.divIcon({ 
              iconSize: new L.Point(100, 20), 
              className: 'label-icon',
              html: '<span>'+props['title']+'</span>'
          });
          this.labelsLayer = L.marker(center, {icon: myIcon, interactive: false});
          this.labelsLayer.addTo(this.map);
          */
      } else {
        /* a feature is not selected */
        if (this.highlightLayer) {
          this.map.removeLayer(this.highlightLayer);
        }
        if (this.labelsLayer) {
          this.map.removeLayer(this.labelsLayer);
        }
      }
    },
    opacity() {
      this.data.setOpacity(this.opacity / 100);
    },
    layer() {
      var dataUrl =
        process.env.VUE_APP_API +
        "/tools/raster/tile/" +
        this.factsheet["identifier"] +
        "/" +
        this.layer["dataset_id"] +
        "/" +
        this.layer["source"] +
        "~/tile/{z}/{x}/{y}.png";

      if (this.data == null) {
        this.data = L.tileLayer(dataUrl, {
          attribution: "",
          maxZoom: 18,
          id: "data",
        }).addTo(this.map);
      } else {
        this.data.setUrl(dataUrl);
      }
      this.loadLegend();
    },
  },
  methods: {
    convertMultiUnits(indicator, units) {
      var value = indicator["value"];
      var area = this.featureList[indicator["fid"]]["properties"]["area"];
      var result = {};
      var native = null;
      units.forEach((u) => {
        if (u["native"] == true) {
          native = u["name"];
        }
      });
      units.forEach((u) => {
        result[u["name"]] = this.convertUnits(
          indicator["value"],
          native,
          u["name"],
          area
        );
      });
      return result;
    },
    convertUnits(value, from, to, area) {
      if (from == to) {
        return value;
      }
      if (from == "m2") {
        if (to == "ha") {
          return value / 10000;
        }
        if (to == "km2") {
          return value / 1000000;
        }
        if (to == "percent") {
          return 100 * (value / area);
        }
      }
      if (from == "ha") {
        if (to == "m2") {
          return value * 10000;
        }
        if (to == "km2") {
          return value / 100;
        }
        if (to == "percent") {
          return 100 * ((value * 10000) / area);
        }
      }
      return null;
    },
    indicatorValue(indicator) {
      /* Return the value of the indicator in the currently selected units. */
      return indicator["units"][this.selectedUnits];
    },
    indicatorValueRaw(indicator) {
      return this.indicatorValueFormatted(indicator, true);
    },
    indicatorValueFormatted(indicator, lotsOfDecimals) {
      var value = this.indicatorValue(indicator);
      if (value == null) {
        return "?";
      }
      var format = this.selectedUnitsInfo["format"];
      var regex = /\/*(\#{1,10})\.{0,1}(\#{0,10})/;
      var match = format.match(regex);
      if (match == null) {
        return value;
      }
      var valueFormatted = value.toFixed(match[2].length);
      if (lotsOfDecimals == true) {
        return format.replaceAll(match[0], value);
      } else {
        return format.replaceAll(match[0], valueFormatted);
      }
    },
    resultsJSON() {
      /* Return a json equivalent of the results. */
      var geojson = {
        type: "FeatureCollection",
        name: "results",
        features: [],
      };
      this.results.forEach((r) => {
        /* Fetch corresponding feature using the fid */
        var feature = this.featureList[r["fid"]];

        /* Add relevant properties to this feature */
        feature["properties"]["value"] = r["units"][this.selectedUnits];
        feature["properties"]["indicator"] = r["indicator"];
        feature["properties"]["level"] = r["level"];
        feature["properties"]["color"] = this.valueToColor(
          r["units"][this.selectedUnits]
        );

        geojson["features"].push(feature);
      });
      return geojson;
    },
    isActive() {
      var key = this.sortBy;
      return { key: true };
    },
    loadMap() {
      if (!this.loaded) {
        return;
      }
      this.map.fitBounds(this.factsheet["info"]["location"].fitbounds);
      this.initMap();
    },
    titleFor(fid) {
      if (fid) {
        var feature = this.featureList[fid];
        if (feature) {
          return feature["properties"]["title"];
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    circleStyle(result) {
      var color = this.valueToColor(result["units"][this.selectedUnits]);
      return (
        "position:relative;margin-left:10px;top:8px;right:3px;float:right;clear:right;display:block;width:20px;height:20px;border-radius:50px;background-color:" +
        color
      );
    },
    valueToColor(value, fallback = "#cccccc") {
      if (value == null) {
        return fallback;
      }
      var color = fallback;
      var cmap = this.colormap;
      var stats = this.resultsStats;
      var spread = Math.abs(
        this.resultsStats["max"] - this.resultsStats["min"]
      );
      if (stats != null) {
        if (spread == 0) {
          color == fallback;
        } else if (value < stats["min"]) {
          color = cmap[0];
        } else if (value > stats["max"]) {
          color = cmap.slice(-1);
        } else if (value >= stats["min"] && value <= stats["max"]) {
          var norm = (value - stats["min"]) / (stats["max"] - stats["min"]);
          var ix = Math.max(0, parseInt(norm * cmap.length) - 1);
          color = cmap[ix];
        } else {
          color = fallback;
        }
      } else {
        color = fallback;
      }
      return color;
    },
    initMap() {
      /* Process the aoi features into the relevant feature collection */
      _.forEach(this.factsheet.aois["features"], (feature) => {
        feature["properties"]["indicators"] = {};
        this.featureCollection.push(feature);
        this.featureList[feature["properties"]["id"]] = feature;
        var ident =
          feature["properties"]["type"] + "_" + feature["properties"]["id"];
        /* 
            Populate the levelProperties while we're iterating over the locations.
          */
        if (feature["properties"]["type"] in this.levelProperties) {
          this.levelProperties[feature["properties"]["type"]]["count"] += 1;
        } else {
          var label = feature["properties"]["type"].toUpperCase();
          var enabled = this.factsheet.info.config.selected_levels.includes(
            feature["properties"]["type"]
          );
          if ("type_label" in feature["properties"]) {
            label = feature["properties"]["type_label"];
          }
          this.levelProperties[feature["properties"]["type"]] = {
            id: feature["properties"]["type"],
            count: 1,
            label: label,
            enabled: enabled,
          };
          /* Set the default to the first enabled aggregation level. */
          console.log("Setting default:");
          if (this.analysisLevel == null && enabled) {
            console.log(feature["properties"]["type"]);
            this.analysisLevel = feature["properties"]["type"];
          }
        }
      });

      /* 
          Iterate over all the factsheet data that we have, and check for the 
          "indicators_info" property, which means that this data file contains
          indicators that we want to add to the list.
         */
      _.forEach(this.factsheet.data, (data) => {
        if (data.hasOwnProperty("indicators_info")) {
          var id = 0;
          _.forEach(data["indicators_info"], (indicatorInfo) => {
            /*
                For each available indicator, push it to the availableIndicators
                list so that it can be displayed in the web interface.
              */

            /* Set the enabled toggle. */
            indicatorInfo["enabled"] =
              this.factsheet.info.config.selected_indicators.includes(
                indicatorInfo["indicator"]
              );

            /* Only add this indicator if it has units and display properly defined. */
            if (
              indicatorInfo.hasOwnProperty("units") &&
              indicatorInfo.hasOwnProperty("display")
            ) {
              this.availableIndicators.push(indicatorInfo);
              this.availableIndicatorsByName[indicatorInfo["indicator"]] =
                indicatorInfo;

              /* 
                  And then, add all the actual indicator values to the 
                  indicatorCollection. This is the list we filter in order to 
                  display the correct values.
                */
              _.forEach(data["indicators"], (indicator) => {
                if (indicator.hasOwnProperty(indicatorInfo["indicator"])) {
                  /*
                      The indicatorCollection only contains a value and a 
                      feature ID (fid) so we know which feature to highlight
                      and with what color.
                    */

                  /* 
                      For the indicators in the collection, precalculate the
                      values in the different available units.
                    */
                  var units = {};

                  id += 1;
                  this.indicatorCollection.push({
                    value: indicator[indicatorInfo["indicator"]],
                    fid: parseInt(indicator["identifier"]),
                    id: id,
                    indicator: indicatorInfo["indicator"],
                    level: indicator["type"],
                    units: units,
                  });
                }
              });
            } else {
              console.log("Indicator not proper, skipping:");
              console.log(indicatorInfo);
            }
          });
          this.resultCollection.push(...data["indicators"]);
        }
      });
      console.log(
        "Done! Added " +
          this.indicatorCollection.length +
          " items to indicatorCollection."
      );

      /* 
        Set the selected indicator to whatever is first on the list. At a later
        time we can customize this based on a factsheet configuration.
        */
      for (const indicator of this.availableIndicators) {
        if (indicator.enabled) {
          this.selectedIndicator = indicator;
          break;
        }
      }

      /* 
          After processing the features, we now need to precalculate all 
          the result values in the different available units. We can only do 
          this now (rather than when loading the results) because in some 
          cases (i.e. percentages) we need the area of the shape to be able to
          calculate a percentage value.
        */
      this.indicatorCollection.forEach((indicator) => {
        var indicatorInfo =
          this.availableIndicatorsByName[indicator["indicator"]];
        indicator["units"] = this.convertMultiUnits(
          indicator,
          indicatorInfo["units"]
        );
      });

      this.updateMap();
    },
    updateMap() {
      /* For an update of the layer containing the aois in the map */
      if (this.analysisLayer) {
        this.map.removeLayer(this.analysisLayer);
      }

      this.analysisLayer = L.geoJson(this.resultsJSON(), {
        interactive: true,
        pane: "data",
        style: (feature) => {
          return {
            fillColor: feature.properties.color,
            weight: 1,
            color: "#ffffff",
            opacity: 1,
            fillOpacity: 1,
          };
        },
        onEachFeature: (feature, layer) => {
          layer.on("mouseover", () => {
            this.featureHighlight = feature["properties"]["id"];
          });
          layer.on("mouseout", () => {
            this.featureHighlight = null;
          });
          layer.bringToBack();
        },
      });
      this.analysisLayer.addTo(this.map);

      if (this.labelsLayer) {
        this.map.removeLayer(this.labelsLayer);
      }

      /*
          if(this.sortBy != null) {
            var labelsGeoJSON = this.labelsGeoJSON()
            this.labelsLayer = L.geoJson(labelsGeoJSON, {
                interactive: false,
                pointToLayer: (feature, latlng) => {
                  var value = _.get(feature.properties.indicators, this.sortBy, feature.properties.ident);
                  if(this.sortBy.endsWith("ha")) {
                    value = parseInt(value)+'ha'
                  }
                  if(this.sortBy.endsWith("perc")) {
                    value = value.toFixed(1)+'%'
                  }
                  var myIcon = L.divIcon({ 
                      iconSize: new L.Point(100, 20), 
                      className: 'label-icon',
                      html: '<span>'+value+'</span>'
                  });
                  return L.marker(latlng, {icon: myIcon, interactive: false});
                },
            });
            this.labelsLayer.addTo(this.map);
          }*/
    },
    highlightFeatureStart(feature_id) {
      this.featureHighlight = feature_id;
    },
    highlighFeatureStop() {
      this.featureHighlight = null;
    },
    labelsGeoJSON() {
      return {
        type: "FeatureCollection",
        name: "aois",
        features: [this.featureList[this.featureHighlight]],
      };
    },
    loadLayer(layer) {
      this.layer = layer;
    },
    setSort(sortBy) {
      if (this.sortBy == sortBy) {
        // If we're sorting by the same value, reverse the order.
        if (this.sortOrder == "asc") {
          this.sortOrder = "desc";
        } else {
          this.sortOrder = "asc";
        }
      } else {
        this.sortBy = sortBy;
      }
      this.updateMap();
    },
  },
  filters: {
    int: function (value) {
      return parseInt(value);
    },
    percent: function (value) {
      return value.toFixed(1) + "%";
    },
    absolute: function (value) {
      if (value > 0) {
        return "+" + parseInt(value);
      }
      if (value < 0) {
        return "−" + parseInt(value * -1);
      }
      return parseInt(value);
    },
    units: function (value) {
      /* convert value to the requested units */

      return "[" + value + "]";
    },
  },
  computed: {
    selectedUnitsInfo() {
      return _.filter(this.availableUnits, (unit) => {
        return unit["name"] == this.selectedUnits;
      })[0];
    },
    enabledIndicators() {
      return _.filter(this.availableIndicators, (indicator) => {
        return indicator["enabled"];
      });
    },
    disabledIndicators() {
      return _.filter(this.availableIndicators, (indicator) => {
        return !indicator["enabled"];
      });
    },
    colormap() {
      var cmap = this.namedColorMaps["Spectral"];
      if (this.selectedIndicator["display"].hasOwnProperty("colormap")) {
        var cmapName = this.selectedIndicator["display"]["colormap"];
        if (cmapName.startsWith("Inv")) {
          cmap = [...this.namedColorMaps[cmapName.substring(3)]].reverse();
        } else {
          cmap = this.namedColorMaps[cmapName];
        }
      }
      return cmap;
    },
    levelPropertiesSorted() {
      var unsorted = [];
      for (const [key, value] of Object.entries(this.levelProperties)) {
        unsorted.push(value);
      }
      var sorted = _.sortBy(unsorted, ["id"], ["desc"]);
      return sorted;
    },
    results() {
      /* filter results to the correct type */
      var results = _.filter(this.indicatorCollection, (result) => {
        if (this.selectedIndicator == null) {
          return false;
        }
        if (
          result["level"] == this.analysisLevel &&
          result["indicator"] == this.selectedIndicator.indicator
        ) {
          return true;
        } else {
          return false;
        }
      });

      /* order by the selected sort order */
      if (this.selectedIndicator != null) {
        //var sorted = _.sortBy(results, ({ value }) => value || '', ['desc',])
        var sorted = _.sortBy(
          results,
          ({ units }) => units[this.selectedUnits] || "",
          ["desc"]
        );
        //var sorted = _.sortBy(results, [function(o) { return o.user; }])
        return _.reverse(sorted);
      } else {
        return results;
      }
    },
    numResults() {
      return this.results.length;
    },
    resultsValues() {
      var vals = [];
      this.results.forEach((result) => {
        vals.push(result["units"][this.selectedUnits]);
      });
      return vals;
    },
    resultsStats() {
      var resultsValues = this.resultsValues;
      if (resultsValues.length > 0) {
        if (this.selectedIndicator["display"].hasOwnProperty("stats")) {
          return this.selectedIndicator["display"]["stats"];
        } else {
          return {
            min: Math.min(...this.resultsValues),
            max: Math.max(...this.resultsValues),
          };
        }
      } else {
        return null;
      }
    },
    features() {
      var features = [];
      this.featureCollection.forEach((feat) => {
        features.push(feat);
      });
      return features;
    },
    resultSet() {
      /* return a resultset of features */
      var resultSet = [];
      this.featureKeys.forEach((key) => {
        var feat = this.featureList[key];
        if (feat["properties"]["type"] == this.analysisLevel) {
          /* add the indicators to the feature */
          this.resultCollection.forEach((item) => {
            var item_ident = item["type"] + "_" + item["identifier"];
            if (
              _.includes(this.indicator, item.indicator) &&
              item_ident == key
            ) {
              feat["properties"]["indicators"][item.indicator] = item;
              //console.log("Assigniing key="+key+" to item...")
              //console.log(item)
            }
          });
          resultSet.push(feat);
        }
        /* fetch the corresponding indicators... */
      });
      return resultSet;
    },
    downloadUrl() {
      if (this.layer == null) {
        return "";
      } else {
        return (
          process.env.VUE_APP_DATABUCKET +
          "/factsheet/" +
          this.factsheet.identifier +
          "/data" +
          this.layer["source"]
        );
      }
    },
    legendClass() {
      return (
        "col-sm-12 col-md-12 col-lg-" +
        (this.layout ? this.layout.legendWidth : 6)
      );
    },
    descriptionClass() {
      return (
        "col-sm-12 col-md-12 col-lg-" +
        (this.layout ? this.layout.descriptionWidth : 6)
      );
    },
  },
};
</script>
<style>
div.label-icon {
  text-align: center;
  pointer-events: none;
}
div.label-icon span {
  font-size: 0.75em;
  background-color: rgba(255, 255, 255, 0);
  border: 0px solid #ddd;
  padding: 1px 3px;
  font-weight: bold;
  color: #000;
  border-radius: 3px;
  display: inline-block;
  pointer-events: none;
}
</style>

<style scoped>
div.quickscanmap {
  margin: 10px 0px 10px 0px;
}
h4 {
  margin: 0px;
  padding: 8px;
  padding-left: 10px;
  font-size: 0.9em;
  width: 100%;
  color: #444;
}
h5 {
  font-size: 0.7em;
  color: #666;
  font-weight: 600;
  padding: 5px 0px 5px 0px;
  margin: 0px;
}
p {
  margin: 0px;
  font-size: 0.6em;
  color: #222;
}
p.attribution {
  font-size: 0.5em;
  padding: 0px 6px 3px 6px;
  color: #888;
}
div.cmd,
div.row {
  background-color: #f5f5f5;
}
a.btn-command:focus,
a.btn-command:active {
  outline: none !important;
  box-shadow: none;
}
a.btn-command {
  background-color: #f5f5f5;
  color: #999;
}
a.btn-command:hover {
  background-color: #eeeeee;
  color: #777;
}
a.btn-command i {
  font-size: 0.8em;
}
div.legend-wrapper {
  padding: 7px;
}

ul.cmd-group {
  display: inline;
  font-size: 0.65em;
  border: 1px solid #bbb;
  border-radius: 2px;
  padding: 0;
  margin: 0;
  margin-left: 5px;
  background-color: #fff;
}
ul.cmd-group li {
  display: inline-block;
  margin: 0px;
  padding: 4px 2px 4px 2px;
}
ul.cmd-group li a.active {
  color: rgb(21, 176, 26);
}
ul.cmd-group li.title {
  padding-left: 0px;
}
ul.cmd-group li.title a {
  background-color: #f5f5f5;
  border-right: 1px solid #ccc;
  padding-right: 4px;
  padding-left: 3px;
  color: #777;
}
ul.cmd-group li a {
  padding-left: 2px;
  padding-right: 2px;
  color: #bbb;
}
ul.cmd-group li a svg {
  color: #aaa;
}
ul.cmd-group a.icon {
  font-size: 0.9em;
}
ul.cmd-group a:hover {
  color: #777;
}

div.layer-selection {
  font-size: 1em;
}
div.layer-selection a.btn-layer {
  color: #007bff;
}
div.layer-selection a.active {
  background-color: #fff;
}
div.layer-selection a.btn-layer:hover {
  color: #0056b3;
}

div.layer-commands {
  font-size: 1em;
}
div.layer-commands a.btn-layer {
  color: #aaa;
}
div.layer-commands a.btn-layer:hover {
  color: #0056b3;
}
.btn:focus,
.btn:active {
  outline: none !important;
  box-shadow: none;
}

div.legend-description p {
  margin-bottom: 5px;
}

form#quickscan-indicators,
form#quickscan-indicators-disabled,
form#quickscan-analysisLevel {
  font-size: 0.75em;
}
form#quickscan-indicators .form-check-input:disabled ~ .form-check-label,
form#quickscan-analysisLevel .form-check-input:disabled ~ .form-check-label {
  color: #aaa;
}

ul#result-list {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
ul#result-list li {
  padding: 0px;
  margin: 0px;
  margin-bottom: 5px;
  margin-left: 5px;
}
ul#result-list li:last-child {
  margin-bottom: 0px;
}
div.result-list-box {
  line-height: 0.95em;
}
div.result-list-box a {
  display: block;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  color: #333;
}
div.result-list-box a:hover {
  border: 1px solid #aaa;
  background-color: #fff;
}
div.result-list-box a:hover h6 {
  color: #007bff;
}
div.result-list-box span.sub {
  font-size: 0.9em;
}
table.mini h6 {
  margin: 0px;
  padding: 0px;
  font-size: 1.1em;
  font-weight: bold;
  color: #c46802;
}
table.mini {
  width: 100%;
  font-size: 0.7em;
  table-layout: fixed;
}
table.mini td,
table.mini th {
  line-height: 1.4em;
}
table.mini,
table.mini tr,
table.mini td {
  margin: 0px;
  padding: 0px;
}
table.mini tr.small {
  font-size: 0.9em;
}
table.mini td,
table.mini th {
  padding-left: 3px;
  padding-right: 3px;
}
table.mini td {
  text-align: center;
  border-left: 1px dotted #888;
}
table.mini th {
  font-weight: bold;
  text-align: center;
  border-bottom: 1px dotted #888;
  border-left: 1px dotted #888;
  padding-left: 3px;
  padding-right: 3px;
}
table.mini td:first-child,
table.mini th:first-child {
  text-align: left;
  padding: 0px;
  width: 100%;
  border-left: 0px;
}
table.mini th.std-w,
table.mini td.std-w {
  width: 58px !important;
}
table.mini tr.section {
  border-top: 1px dotted #888;
}
table.mini tr.section th {
  border: none;
  font-weight: bold;
  padding: 0px;
  padding-top: 4px;
  font-size: 0.95em;
  color: #444;
}
div.sort-options {
  border-bottom: 0px solid #ccc;
  margin-bottom: 5px;
  font-size: 0.6em;
  margin: 0px 5px 0px 5px;
  padding: 5px;
  padding-top: 0px;
  font-weight: bold;
  color: #666;
}

a.sort-option {
  font-weight: normal;
}
li.result-item div.wrapper {
  padding: 0px;
  font-size: 0.8em;
  display: block;
  border: 1px solid #ccc;
  background-color: #fff;
  color: #333;
  margin-right: 10px;
  padding: 6px;
}
li.result-item div.wrapperActive {
  background-color: rgba(255, 255, 0, 0.5);
  //cursor:pointer;
}
a.sort-by {
  //color:#666;
}
a.sort-by-selected {
  color: #000;
  text-decoration: underline;
}
.column-wrapper {
  column-count: 3;
}
</style>
